import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { cloneControl } from '../helper/script/cloneAbstract';
import { EFormHelper } from '../helper/script/helper';
import { UUID } from '../helper/script/uuid';
import { ValidatorConfigure } from './validator';
export class NewControls {
   eForm: FormGroup;
   helper = new EFormHelper();
   uuid = new UUID();
   validators = new ValidatorConfigure();
   constructor(private fb: FormBuilder, public eform: FormGroup) {
      this.eForm = eform;
   }

   get getNewSection(): FormGroup {
      return this.fb.group({
         name: this.fb.group({en: '', th: '',cn: ''}),
         key: this.uuid.getUUIDV4,
         classes: 'field-one',
         description: this.fb.group({en: '', th: '',cn: ''}),
         permissions: this.fb.array([this.fb.group({ type: 'GROUP', id: 'Everyone', name: 'Everyone', groupCode: 'Everyone', siteCode: 'Everyone', authority: 'Edit' }),
         this.fb.group({ type: 'GROUP', id: 'Everyone', name: 'Everyone', groupCode: 'Everyone', siteCode: 'Everyone', authority: 'View' })]),
         fields: this.fb.array([]),
      });
   }

   get getNewTextBox(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '',cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-textbox', Validators.required],
         type: ['single_line', Validators.required],
         placeholder: this.fb.group({en: '', th: '',cn: ''}),
         maxLength: 150,
         required: [false, Validators.required],
         isRegex: [false, Validators.required],
         display: [true, Validators.required]
      });
   }

   get getNewDate(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '',cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-date', Validators.required],
         type: ['date', Validators.required], // date, time
         placeholder: this.fb.group({en: 'dd-mmmm-yyyy', th: 'dd-mmmm-yyyy',cn: 'dd-mmmm-yyyy'}),
         required: [false, Validators.required],
         display: [true, Validators.required],
         dateOption: [0], // 0 = B.C., 1 = B.E.
         dateFormat: [0], // 0 = dd mmmm yyyy, 1 = dd mmm yyyy, 2 = dd mm yyyy, 3 = dd mm yy
         timeOption: [''], // 0 = 24hrs, 1 = AM/PM
         timeFormat: [''], // 0 = hh:mm, 1 = hh:mm:ss, 2 = hh:mm:ss.sss
         separateDate: [0], // 0 = Hyphen -, 1 = Slash /, 2 = Space
      });
   }

   get getNewNumber(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-number', Validators.required],
         type: ['integer', Validators.required], // integer, decimal, percent
         placeholder: this.fb.group({en: '', th: '',cn: ''}),
         required: [false, Validators.required],
         display: [true, Validators.required],
         decimalPlace: '',
         rangeStart: ['', [this.validators.fieldBadRange.bind(this), this.validators.fieldMustNotBeDash.bind(this), this.validators.fieldMustDecimal.bind(this), this.validators.fieldDecimalMath.bind(this)]],
         rangeEnd: ['', [this.validators.fieldBadRange.bind(this), this.validators.fieldMustNotBeDash.bind(this), this.validators.fieldMustDecimal.bind(this), this.validators.fieldDecimalMath.bind(this)]]
      });
   }

   get getNewRadio(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-radio', Validators.required],
         type: ['radio', Validators.required], // radio, checkbox, toggle
         required: [false, Validators.required],
         display: [true, Validators.required],
         radioOption: 0, // 0 = Yes/No, 1 = True/False, 2 = Enable/Disable, 3 = On/Off, 4 = Read/UnRead
         radioDefaultValue: '',
      });
   }

   get getNewEmail(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-email', Validators.required],
         type: ['email', Validators.required],
         placeholder: this.fb.group({en: '', th: '', cn: ''}),
         required: [false, Validators.required],
         display: [true, Validators.required],
      });
   }

   get getNewWebSite(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-website', Validators.required],
         type: ['website', Validators.required],
         placeholder: this.fb.group({en: '', th: '', cn: ''}),
         required: [false, Validators.required],
         display: [true, Validators.required],
      });
   }

   get getNewSignature(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldType: ['f-signature', Validators.required],
         type: ['signature', Validators.required],
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         required: [false, Validators.required],
         display: [true, Validators.required],
         includePublicKey: [false]
      });
   }

   get getNewPhone(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-phone', Validators.required],
         type: ['landline_type1', Validators.required],
         required: [false, Validators.required],
         display: [true, Validators.required],
      });
   }

   get getNewCurrency(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-currency', Validators.required], // bath, international
         type: ['symbol', Validators.required],
         subType: ['prefix', Validators.required],
         currency: ['฿'],
         required: [false, Validators.required],
         display: [true, Validators.required],
         rangeStart: ['', [this.validators.fieldBadRange.bind(this), this.validators.fieldMustNotBeDash.bind(this)]],
         rangeEnd: ['', [this.validators.fieldBadRange.bind(this), this.validators.fieldMustNotBeDash.bind(this)]],
         order: ['']
      });
   }

   get getNewChoice(): FormGroup {
      const _initChoice = this.getInitChoice;
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-choice', Validators.required],
         type: ['dropdown', Validators.required], // dropdown, radio, checkbox
         required: [false, Validators.required],
         display: [true, Validators.required],
         choiceLayout: [0],
         choiceOption: [0],
         choiceDefaultValue: [1],
         tempLookupDefault: [1],
         choiceLookUp: this.fb.group({ id: '', tableName: '', columnName: ''}),
         choiceTmp: _initChoice,
         choices: cloneControl<FormArray>(_initChoice)
      });
   }


   get getInitChoice(): FormArray {
      return this.fb.array([this.fb.group({ label: this.fb.group({en: ['Option1'], th: ['ตัวเลือกที่ 1'],cn: ['Option1']}),
      value: ['1'], isPrompt: false }),
                                         this.fb.group({ label: this.fb.group({en: ['Option2'], th: ['ตัวเลือกที่ 2'],cn: ['Option2']}),
      value: ['2'], isPrompt: false }),
                                         this.fb.group({ label: this.fb.group({en: ['Option3'], th: ['ตัวเลือกที่ 3'],cn: ['Option3']}),
      value: ['3'], isPrompt: false })]);
   }

   get getNewAddress(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         addressLabel: this.fb.group({
            'labelAddress1' : this.fb.group({en : 'Address Line 1', th: 'ที่อยู่บรรทัด 1',cn : 'Address Line 1'}),
            'labelAddress2' : this.fb.group({en : 'Address Line 2', th: 'ที่อยู่บรรทัด 2',cn : 'Address Line 2'}),
            'labelProvince' : this.fb.group({en : 'Province', th: 'จังหวัด',cn : 'Province'}),
            'labelDistrict' : this.fb.group({en : 'District', th: 'อำเภอ',cn : 'District'}),
            'labelSubDistrict' : this.fb.group({en : 'Sub-District', th: 'ตำบล',cn : 'Sub-District'}),
            'labelZipcode' : this.fb.group({en : 'Zip code', th: 'รหัสไปรษณีย์',cn : 'Zip code'}),
            'labelPostal' : this.fb.group({en : 'Postal / Zipcode', th: 'ไปรษณีย์',cn : 'Postal / Zipcode'}),
            'labelCity' : this.fb.group({en : 'City', th: 'เมือง',cn : 'City'}),
            'labelState' : this.fb.group({en : 'State', th: 'รัฐ',cn : 'State'}),
            'labelCountry' : this.fb.group({en : 'Country', th: 'ประเทศ',cn : 'Country'}),
         }),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-address', Validators.required],
         type: ['local', Validators.required],
         display: [true, Validators.required],
         address1: this.fb.group({ include: true, required: true, defaultValue: this.fb.group({ value: ''})}),
         address2: this.fb.group({ include: true, required: true, defaultValue: this.fb.group({ value: ''})}),
         province: this.fb.group({ include: true, required: true, defaultValue: {code: '', name_th: '', name_en: '', name_cn: ''}}),
         district: this.fb.group({ include: true, required: true, defaultValue: {code: '', name_th: '', name_en: '', name_cn: ''}}),
         subDistrict: this.fb.group({ include: true, required: true, defaultValue: {code: '', name_th: '', name_en: '', name_cn: '', zip_code: ''}}),
         zipCode: this.fb.group({ include: true, required: true, defaultValue: {zip_code: ''}}),
      }, {validators : this.validators.includeValidator});
   }

   get getNewName(): FormGroup {
      const _group = this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         nameLabel: this.fb.group({
            'labelTitle' : this.fb.group({en : 'Title', th: 'คำนำหน้าชื่อ',cn : 'Title'}),
            'labelName' : this.fb.group({en : 'Name', th: 'ชื่อ',cn : 'Name'}),
            'labelSurname' : this.fb.group({en : 'Surname', th: 'นามสกุล',cn : 'Surname'}),
            'labelMiddle' : this.fb.group({en : 'Middle Name', th: 'ชื่อกลาง',cn : 'Middle Name'}),
            'labelInitial' : this.fb.group({en : 'Initial', th: 'ตัวย่อ',cn : 'Initial'}),
         }),
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-name', Validators.required],
         type: ['name', Validators.required],
         required: [false, Validators.required],  // this field effect to name and surname
         display: [true, Validators.required],
         title: this.fb.group({ include: false, required: {value: false, disabled: true}, type: 0,
          // 0 = simple, 1 = advance, 2 = customize
          // this case 0 simple get data from /config/title.ts
          // this case 1 get data from API with master data
          // this case 2 get data from xml object
          customizeData: this.fb.array([this.fb.group({id: 0, th: ['นาย', Validators.required], en: ['Mr.', Validators.required], cn: ['Mr.', Validators.required] }),
          this.fb.group({id: 1, th: ['นาง', Validators.required], en: ['Mrs.', Validators.required], cn: ['Mrs.', Validators.required]}),
          this.fb.group({id: 2, th: ['นางสาว', Validators.required], en: ['Miss', Validators.required], cn: ['Miss', Validators.required]}),
          this.fb.group({id: 3, th: ['ดร.', Validators.required], en: ['Dr.', Validators.required], cn: ['Dr.', Validators.required]}),
          this.fb.group({id: 9001, th: ['อื่นๆ', Validators.required], en: ['Other', Validators.required], cn: ['Other', Validators.required]})
          ])}),
         middleName: this.fb.group({ include: false, required: {value: false, disabled: true}}),
         initial: this.fb.group({ include: false, required: {value: false, disabled: true}}),
      });
      return _group;
   }

   get getNewUpload(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-upload', Validators.required],
         type: ['upload', Validators.required],
         required: [false, Validators.required],
         display: [true, Validators.required],
         allowType: [''],
         maximumSize : [],
         maximumFile : [],
      });
   }

   get getNewTable(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['f-table', Validators.required],
         type: ['table', Validators.required],
         required: [false, Validators.required],
         display: [true, Validators.required],
         columns: this.fb.array([]),
         minItem: ['0', [this.validators.checkValueItem.bind(this)]],
         maxItem: ['', [this.validators.checkValueItem.bind(this)]]
      });
   }

   get getNewTableTextBox(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExistingColumn.bind(this)]],
         fieldType: ['t-textbox', Validators.required],
         type: ['single_line', Validators.required],
         placeholder: this.fb.group({en: '', th: '', cn: ''}),
         maxLength: 150,
         required: [false, Validators.required],
         isRegex: [false, Validators.required],
         display: [true, Validators.required]
      });
   }

   get getNewTableNumber(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExistingColumn.bind(this)]],
         fieldType: ['t-number', Validators.required],
         type: ['integer', Validators.required],
         placeholder: this.fb.group({en: '', th: '', cn: ''}),
         maxLength: 150,
         required: [false, Validators.required],
         isRegex: [false, Validators.required],
         display: [true, Validators.required],
         decimalPlace: '',
         rangeStart: ['', [this.validators.fieldBadRange.bind(this), this.validators.fieldMustNotBeDash.bind(this), this.validators.fieldMustDecimal.bind(this), this.validators.fieldDecimalMath.bind(this)]],
         rangeEnd: ['', [this.validators.fieldBadRange.bind(this), this.validators.fieldMustNotBeDash.bind(this), this.validators.fieldMustDecimal.bind(this), this.validators.fieldDecimalMath.bind(this)]],
         typeSummary: ['none', Validators.required]
      });
   }

   get getNewTableCurrency(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExistingColumn.bind(this)]],
         fieldType: ['t-currency', Validators.required], // bath, international
         type: ['symbol', Validators.required],
         subType: ['prefix', Validators.required],
         currency: ['฿'],
         required: [false, Validators.required],
         display: [true, Validators.required],
         decimalPlace: '',
         rangeStart: ['', [this.validators.fieldBadRange.bind(this), this.validators.fieldMustNotBeDash.bind(this)]],
         rangeEnd: ['', [this.validators.fieldBadRange.bind(this), this.validators.fieldMustNotBeDash.bind(this)]],
         typeSummary: ['none', Validators.required],
         order: ['']
      });
   }

   get getNewTableDate(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['t-date', Validators.required],
         type: ['date', Validators.required], // date, time
         placeholder: this.fb.group({en: 'dd-mmmm-yyyy', th: 'dd-mmmm-yyyy', cn: 'dd-mmmm-yyyy'}),
         required: [false, Validators.required],
         display: [true, Validators.required],
         dateOption: [0], // 0 = B.C., 1 = B.E.
         dateFormat: [0], // 0 = dd mmmm yyyy, 1 = dd mmm yyyy, 2 = dd mm yyyy, 3 = dd mm yy
         timeOption: [''], // 0 = 24hrs, 1 = AM/PM
         timeFormat: [''], // 0 = hh:mm, 1 = hh:mm:ss, 2 = hh:mm:ss.sss
         separateDate: [0], // 0 = Hyphen -, 1 = Slash /, 2 = Space
      });
   }

   get getNewTablePhone(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['t-phone', Validators.required],
         type: ['landline_type1', Validators.required],
         required: [false, Validators.required],
         display: [true, Validators.required],
      });
   }

   get getNewTableEmail(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['t-email', Validators.required],
         type: ['email', Validators.required],
         placeholder: this.fb.group({en: '', th: '', cn: ''}),
         required: [false, Validators.required],
         display: [true, Validators.required],
      });
   }

   get getNewTableWebSite(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['t-website', Validators.required],
         type: ['website', Validators.required],
         placeholder: this.fb.group({en: '', th: '', cn: ''}),
         required: [false, Validators.required],
         display: [true, Validators.required],
      });
   }


   get getNewTableRadio(): FormGroup {
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['t-radio', Validators.required],
         type: ['dropdown', Validators.required],
         required: [false, Validators.required],
         display: [true, Validators.required],
         radioOption: 0, // 0 = Yes/No, 1 = True/False, 2 = Enable/Disable, 3 = On/Off, 4 = Read/UnRead
         radioDefaultValue: '',
      });
   }

   get getNewTableChoice(): FormGroup {
      const _initChoice = this.getInitChoice;
      return this.fb.group({
         labelName: this.fb.group({en: '', th: '', cn: ''}),
         key: this.uuid.getUUIDV4,
         fieldName: ['', [Validators.required, this.validators.fieldExisting.bind(this)]],
         fieldType: ['t-choice', Validators.required],
         type: ['dropdown', Validators.required],
         required: [false, Validators.required],
         display: [true, Validators.required],
         choiceLayout: [0],
         choiceOption: [0],
         choiceDefaultValue: [1],
         tempLookupDefault: [1],
         choiceLookUp: this.fb.group({ id: '', tableName: '', columnName: ''}),
         choiceTmp: _initChoice,
         choices: cloneControl<FormArray>(_initChoice)
      });
   }

}


